function showPreviewPopupOld() {
  var canvas = document.getElementById("preview-canvas");
  var dataURL = canvas.toDataURL('image/png', 1);
  $('.main_priview_img img').attr('src',dataURL);

  var x = 0;
  var intervalID = setInterval(function () {
    const newDataURL = canvas.toDataURL('image/png', 1);
    $('.main_priview_img img').attr('src', newDataURL);
    if (++x === 5) {
      window.clearInterval(intervalID);
    }
  }, 1000);

  $.fancybox.open([
    { 
      src : '#preview_image', 
      type : 'inline', 
      touch: false, 
      animationDuration: 0,
      beforeClose: function() {
        if (intervalID) window.clearInterval(intervalID);
      }
    }
  ]);
}

function showPreviewPopupNew() {
  const canvasWrapper = $('.canvas-wrapper');
  const canvasWrapperHeight = canvasWrapper.height();
  const newCanvas = canvasWrapper.get(0);
  $('.main_priview_img').html(newCanvas);
  $('.gallery-wrap').prepend(`<div class="canvas-wrapper-fake" style="height: ${canvasWrapperHeight}px"></div>`);

  var offsetY = window.pageYOffset;
  $.fancybox.open([
    { 
      src : '#preview_image', 
      type : 'inline', 
      touch: false, 
      animationDuration: 0,
      afterLoad: function(){
        offsetY = window.pageYOffset;
        $('html').css({ height: '100vh' });
        $('body').addClass('fixed');  
        $('body').css({ top: -offsetY + 'px' });
      },
      afterClose: function(){
        $('html').css({ height: '' });
        $('body').removeClass('fixed');
        $(window).scrollTop(offsetY);
        if ($('.gallery-wrap .canvas-wrapper').length === 0) {
          $('.gallery-wrap').prepend(newCanvas);
        }
        $('.canvas-wrapper-fake').remove();
      }
    }
  ]);  
}

$(document).on("click",".preview_btn, .js_preview_btn",function(e){
  e.preventDefault();
  check_valid();
  if($(".customily_option").hasClass("customily-required-error") == false){
    if ($(window).width() < 798) {
      console.log('showPreviewPopupNew', showPreviewPopupNew)
      showPreviewPopupNew();
    } else {
      console.log('showPreviewPopupOld', showPreviewPopupOld)

      showPreviewPopupOld();
    }
    ga('send', 'event', 'Click Preview Button Customily', 'Clicked Preview Button', 'clicked');
  }else{
    alert("Please check your design once again. Some required options have been left empty, unselected, or wrongly filled.");
   	$("#customily-cart-btn").click();
  }
})

$(document).on("click",".preview_btn_anchor",function(e){
  e.preventDefault();
  check_valid();
  if($(".customily_option").find(".customily-required-label").length == false){
    showPreviewPopupNew();
    ga('send', 'event', 'Preview Button Anchor', 'Clicked Preview Button', 'clicked');
  }else{
    alert("Please check your design once again. Some required options have been left empty, unselected, or wrongly filled.");
    return;
   	$("#customily-cart-btn").click();
  }
})

// add swatch option to preview popup

// function addDropdownOptions() {
//   $('#preview_image .bt-dropdown').remove();
//   console.log('swatch_options', $('.swatch_options .swatch'));
//   let dropdownOptions = '';
//   const quantity = $('#quantity').val();
//   $("#preview_image .product-quantity-box input").val(quantity);
//   $('.swatch_options .swatch.js-click-Size').each(function() {
//     const title = $(this).find('.option_title').html();
// //     const titleValue = $(this).find('.option_title span').text();
//     const titleValue = $(this).find('input:checked+.swatch-element').data('value');
//     const titleLabel = title.split('<span>')[0].trim();
//     const values = $(this).find('.swatch-element:not(.soldout)');
//     const currentClass = $(this).attr('class');
//     let dropdownMenu = '';
//     values.each(function() {
//       const isColor = $(this).hasClass('color');
//       const val = $(this).data('value');
//       const checked = val === titleValue;
//       if (isColor) {
//         let bg = $(this).find('label').css('background-image');
//         bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
//         dropdownMenu += `<li class="text-ellipsis color ${checked ? 'active' : ''}" title="${val}"><img src="${bg}"/><span class="text-ellipsis">${val}</span></li>`;
//       } else {
//         dropdownMenu += `<li class="text-ellipsis ${checked ? 'active' : ''}" title="${val}">${val}</li>`;
//       }
//     })
//     dropdownOptions += `
// 		<div class="bt-dropdown dropup">
//           <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
// 			<div class="text-ellipsis" title="${titleValue}"><span class="label">${titleLabel}:</span> <span class="value">${titleValue}</span></div>
// 			<img src="https://cdn.shopify.com/s/files/1/0608/4961/9105/t/20/assets/caret-down.svg?v=1653962620" class="caret-icon" />
//           </button>
//           <ul class="dropdown-menu" data-target-class="${currentClass}">
// 			${dropdownMenu}
//           </ul>
//         </div>`;
//   })
//   $('#preview_image .swatch_options_clone').prepend(dropdownOptions);
//   $('.bt-dropdown .dropdown-menu li:not(.active)').click(function() {
//   	const targetClass = $(this).parent().data('target-class');
//     const val = $(this).text();
//     console.log('val', val);
//     $(`.${targetClass.split(' ').join('.')} .swatch-element[data-value="${CSS.escape(val)}"]`).prev().click();
//     $(this).parents('.bt-dropdown').find('.dropdown-toggle .value').html(val);
//     setTimeout(function() {
//       const canvas = document.getElementById("preview-canvas");
//       const dataURL = canvas.toDataURL('image/png');
//       $('.main_priview_img img').attr('src',dataURL);
//     }, 2000)
//     addDropdownOptions();
//   })
// }

function showStickyPreviewProduct() {
// // define an observer instance
//   const observer = new IntersectionObserver(onIntersection, {
//     root: null,   // default is the viewport
//     threshold: 0 // percentage of taregt's visible area. Triggers "onIntersection"
//   })

//   // callback is called on intersection change
//   function onIntersection(entries, opts){
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         if ($('.preview-image-sticky').length) {
//           $('.product-images-wrapper').removeClass('preview-image-sticky');
//           $('.extend-action').hide();
//           $('.js-product-page-gallery').show();
//           $('.extend-info').hide();
//           $('.product-images-wrapper').css({height: 'auto'});
//           $('.js-check-viewport').css({ height: 0 });
//           $('#smartwishlist').show();
//         }
//       } else {
//         if ($('.js-product-page-gallery .canvas-wrapper').length && !isInViewport('.product-images-wrapper') && $('.preview-image-sticky').length === 0) {
//           const productImageHeight = $('.product-images-wrapper').height();
//           $('.product-images-wrapper').addClass('preview-image-sticky');
//           $('.extend-info').fadeIn();
//           $('.js-product-page-gallery').hide();
//           $('#smartwishlist').hide();
//           $('.js-check-viewport').css({ height: productImageHeight });
//         }
//       }
//     })
//   }

//   // Use the observer to observe an element
//   observer.observe(document.querySelector('.swatch_options'))
  
  let recentScroll = false;
  let delay;
  $(window).scroll(function(){
    if(!recentScroll) {
      recentScroll = true;
      window.setTimeout(() => { recentScroll = false; }, 200)

      if (isInViewport('.swatch_options')) {
        if ($('.preview-image-sticky').length) {
          $('.extend-action').hide();
          $('.extend-info').hide();
          $('.js-product-page-gallery').show();
          $('.product-images-wrapper').css({height: 'auto'});
          $('.product-images-wrapper').removeClass('preview-image-sticky');
          $('.js-check-viewport').css({ height: 0 });
          $('#smartwishlist').show();
        }
      } else {
        if ($('.js-product-page-gallery .canvas-wrapper').length && !isInViewport('.product-images-wrapper') && $('.preview-image-sticky').length === 0) {
          const productImageHeight = $('.product-images-wrapper').height();
          $('.product-images-wrapper').addClass('preview-image-sticky');
          $('.extend-info').fadeIn();
          $('.js-product-page-gallery').hide();
          $('#smartwishlist').hide();
          $('.js-check-viewport').css({ height: productImageHeight });
        }
      }
    }
  });
}

function isInViewport(element) {
  const elementTop = $(element).offset().top;
  const elementBottom = elementTop + $(element).outerHeight();
  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
        window.location.reload() 
    }
});

$(document).ready(function(){
  if ($(window).width() < 768 && $('body').hasClass('product-custom')) {
    const intervalCtm = setInterval(function() {
      if ($('#customily-options .swatch').length) {
        showStickyPreviewProduct();
//         $('#customily-options input, #customily-options select').change(function() {
//           if ($('.product-images-wrapper.preview-image-sticky').length === 0 && !isInViewport('.swatch_options')) {
//             const productImageHeight = $('.product-images-wrapper').height();
//             $('.product-images-wrapper').addClass('preview-image-sticky');
//             $('.extend-info').fadeIn();
//             $('.js-product-page-gallery').hide();
//             $('#smartwishlist').hide();
//             $('.js-check-viewport').css({ height: productImageHeight });
//           }
//         });
        clearInterval(intervalCtm);
      }
    }, 500)
  }
  
  $(".scoll_to_review,.m_scoll_to_review").click(function(e){
   $("#looxReviews").get(0).scrollIntoView();
  })
  
  $('#preview_image .buy_now').click(function() {
    ga('send', 'event', 'Preview Popup Action', 'Clicked Buy Now', 'buy now');
    $('#preview_image .shopify-payment-button__button--unbranded').click();
    $(this).text('Loading');
    $(this).prop('disabled', true);
    $(this).css({ opacity: 0.5, cursor: 'not-allowed' });
  })
  // $('#preview_image .add_to_cart').click(function() {
  //   ga('send', 'event', 'Preview Popup Action', 'Clicked Add To Cart', 'add to cart');
  //   $('#customily-cart-btn').click();
  //   $(this).html('<span>Adding to Cart...</span>');
  //   $(this).prop('disabled', true);
  //   $(this).css({ opacity: 0.5, cursor: 'not-allowed' });
  // })
  $('body').on('click', '#preview_image .add_to_cart', function(){
    ga('send', 'event', 'Preview Popup Action', 'Clicked Add To Cart', 'add to cart');
    $('#customily-cart-btn').click();
    $(this).html('<span>Adding to Cart...</span>');
    $(this).prop('disabled', true);
    $(this).css({ opacity: 0.5, cursor: 'not-allowed' });
  });
//   $("#preview_image .product-quantity-box input").on("propertychange change keyup paste input", function(){
//     const val = $(this).val();
//     $('#quantity').val(val);
//   });
  
  $('.js_shrink_btn').click(function() {
  	$('.extend-action').hide();
    $('.js-product-page-gallery').hide();
    $('.extend-info').fadeIn();
    $('.product-images-wrapper').css({height: 64});
    ga('send', 'event', 'Preview Panel Product Page', 'Clicked Preview Panel Shrink', 'shrink');
  })
  $('.js_extend_btn').click(function() {
  	$('.extend-action').fadeIn();
    $('.js-product-page-gallery').fadeIn(300);
    $('.extend-info').hide();
    const productImageHeight = $('.js-product-page-gallery').height();
    $('.product-images-wrapper').css({height: productImageHeight + 24});
    ga('send', 'event', 'Preview Panel Product Page', 'Clicked Preview Panel Extend', 'extend');
  })
  $('.js_preview_btn').click(function() {
    ga('send', 'event', 'Preview Panel Product Page', 'Clicked Preview Panel Preview', 'preview');
  })
})



function check_valid(){
  firstLoad = false;
  var rad = [];
  var sele = [];
  var text = [];
  var file = [];
  $("form.shopify-product-form #customily-options input[type='radio']").each(function(){
    rad.push($(this).attr("name"));
  });
  $("form.shopify-product-form #customily-options select").each(function(){
    sele.push($(this).attr("name"));
  });
  $("form.shopify-product-form #customily-options input[type='text']").each(function(){
    text.push($(this).attr("name"));
  });
  $("form.shopify-product-form #customily-options input[type='file']").each(function(){
    file.push($(this).attr("name"));
  });

  var uni = $.unique(rad);
  var sele = $.unique(sele);
  for(var i=0;i<uni.length;i++){
    var k = $("input[name='"+ $.escapeSelector(uni[i])+ "']:checked").attr('name');
    if(k == undefined){
      $("input[name='"+ $.escapeSelector(uni[i]) +"']").closest( ".customily_option").addClass("customily-required-error");
    }
    else{
      $("input[name='"+ $.escapeSelector(uni[i]) +"']:checked").closest( ".customily_option").removeClass("customily-required-error");
    }
  }

  for(var i=0;i<sele.length;i++){
    var k = $("select[name='"+ $.escapeSelector(sele[i])+"']").val();
    if(k == undefined){
      $("select[name='"+ $.escapeSelector(sele[i]) +"']").closest( ".customily_option").addClass("customily-required-error");
    }
    else{
      $("select[name='"+ $.escapeSelector(sele[i]) +"']").closest( ".customily_option").removeClass("customily-required-error");
    }
  }

  for(var i=0;i<text.length;i++){
    var k = $("input[name='"+ $.escapeSelector(text[i]) +"']").val();
    if(k == ''){
      $("input[name='"+ $.escapeSelector(text[i]) +"']").closest( ".customily_option").addClass("customily-required-error");
    }
    else{
      $("input[name='"+ $.escapeSelector(text[i]) +"']").closest( ".customily_option").removeClass("customily-required-error");
    }
  }
  for(var i=0;i<file.length;i++){
    var buttonRemove = $("input[name='"+ $.escapeSelector(file[i]) +"']").siblings('.cl_remove-image');
    if($(buttonRemove).is(":hidden")){
      $("input[name='"+ $.escapeSelector(file[i]) +"']").closest( ".customily_option").addClass("customily-required-error");
    } else{
      $("input[name='"+ $.escapeSelector(file[i]) +"']").closest( ".customily_option").removeClass("customily-required-error");
    }
  }
  
  const errorFields = $('.customily_option.customily-required-error');
  if (errorFields.length > 0) {
    $('html, body').animate({
      scrollTop: errorFields.eq(0).offset().top - 100
    }, 300);
  }
}




  function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  $(document).ready(function(){
    const MIN_PEOPLE = 3;
    const MAX_PEOPLE = 8;
    const randomPe = getRandomInt(MIN_PEOPLE, MAX_PEOPLE);
    $("#people-available").text(randomPe);    
  })
  